import PAYMENT_METHODS from '@activities/order/OrderActivity/components/PaymentMethod/constants/paymentMethods';
import usePaymentMethods from '@activities/order/OrderActivity/components/PaymentMethod/hooks/usePaymentMethods';
import MethodItem from '@activities/order/OrderActivity/components/PaymentMethod/MethodItem';
import { PaymentMethod } from '@models/order';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { orderActions } from '@store/order/orderSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import OrderSheetLayout from '../common/OrderSheetLayout';

declare module '@stackflow/config' {
    interface Register {
        OrderPaymentMethodBottomSheet: {};
    }
}

/** 신용카드·간편카드 외의 결제 수단 선택. 고르는 즉시 반영하고 닫는다. */
const OrderPaymentMethodBottomSheet: ActivityComponentType<'OrderPaymentMethodBottomSheet'> = () => {
    const { t } = useTranslation('order');
    const { pop } = useFlow();
    const dispatch = useDispatch();
    const { paymentMethod } = useCalculatedRequest();
    const { otherMethods } = usePaymentMethods();
    const handleSelect = (method: PaymentMethod) => {
        dispatch(orderActions.setPaymentMethod(method));
        pop();
    };
    return (
        <BottomSheet>
            <OrderSheetLayout title={t('paymentMethod.other')}
                closeLabel={t('paymentMethod.close')}
                onClose={pop}>
                {otherMethods.map((method) => (
                    <MethodItem key={method}
                        icon={PAYMENT_METHODS[method].icon}
                        label={t(PAYMENT_METHODS[method].nameKey)}
                        isSelected={paymentMethod === method}
                        onClick={() => handleSelect(method)} />
                ))}
            </OrderSheetLayout>
        </BottomSheet>
    );
};

export default OrderPaymentMethodBottomSheet;
